// Libraries
var React = require('react');
var PubSub = require('pubsub-js');
var $ = require('jquery');
var dateFormat = require('dateformat');

// Styles
require('./MatchDetails.scss');

// Components
var VideoEmbed = require('../../Video/VideoEmbed');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

class MatchDetailsModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			showSelf: false,
			showAudio: this.props.data.fixture.audio !== null,
			showPlayer: false
		};
		PubSub.subscribe('StartMdc', this.startMdcHandler);
	}

	startMdcHandler = () => {
		this.setState({showSelf: true});
	}

	playAudio = () => {
		this.setState({ showPlayer: true }, () => {
			setTimeout(this.checkForiFrame, 1000);
		});
	}

	checkForiFrame = () => {
		let iframeId = $('iframe.mwEmbedKalturaIframe').prop('id');
		let iframe = window.frames[iframeId];
		if(iframe) {
			let container = iframe.document.getElementsByClassName("controlsContainer")[0];
			if(container) {
				container.style.cssText = 'background:none; background-color: #000A3C';
			}
		}
	}

	render() {
		return (
			<div className={"MatchDetails"  + (this.state.showSelf ? "" : " hide")}>                
				<div className="MatchDetails__wrapper">
					{ this.props.data.fixture.competition.darkCrest &&
							<div className="MatchDetails__league">
								<img src={PlaceholderImg} data-src={this.props.data.fixture.competition.darkCrest.url} alt={this.props.data.fixture.competition.darkCrest.altText} />
							</div>
					}
					<div className="MatchDetails__details">
						<p className="tags">
							<a href={this.props.data.fixture.tag.url} rel="nofollow">{this.props.data.fixture.tag.hashtag} </a>
						</p>
						<p>{this.props.data.fixture.kickOff ? (dateFormat(this.props.data.fixture.kickOff, "dd mmm yyyy") + " - ") : ""} {this.props.data.fixture.competition.name}</p>
						<p className="location">{this.props.data.fixture.stadium.displayName}</p>
						{this.props.data.fixture.referee && <p>Referee: {this.props.data.fixture.referee}</p>}
						<div className="MatchDetails__audio">
							{this.state.showAudio && !this.state.showPlayer &&
									<button onClick={this.playAudio}>Audio commentary</button>
							}
							{this.state.showPlayer &&
									<VideoEmbed type="STREAM" data={this.props.data.fixture.audio} audioOnly />
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

module.exports = MatchDetailsModule;



// WEBPACK FOOTER //
// ./src/components/MDC/MatchDetails/MatchDetailsModule.js